import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '../stores/user'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: { name: 'bankAccounts' },
    },
    {
      path: '/login',
      name: 'login',
      meta: { hideTopBar: true, requiresAuth: false },
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/bank-accounts',
      name: 'bankAccounts',
      component: () => import('../views/Accounts/AccountsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/transactions/:accountNumber?',
      name: 'transactions',
      props: true,
      component: () => import('../views/Transactions/TransactionsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/transaction/:id',
      name: 'transaction',
      props: true,
      component: () => import('../views/Transactions/TransactionView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/exports',
      name: 'exports',
      props: true,
      component: () => import('../views/Exports/TransactionCodingExportView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/sweeps',
      name: 'sweeps',
      component: () => import('../views/Sweeps/SweepsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/sweep/:id',
      name: 'sweep',
      props: true,
      component: () => import('../views/Sweeps/SweepView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/Settings/SettingsView.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/validation-categories',
          name: 'validation-categories',
          component: () => import('../views/Settings/Validation/ValidationCategoriesView.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/bank-period-cutoffs',
          name: 'bank-period-cutoffs',
          component: () => import('../views/Settings/BankPeriodCutoffs/BankPeriodCutoffsView.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/groups',
          name: 'groups',
          component: () => import('../views/Settings/ManagementGroups/ManagementGroupsView.vue'),
          meta: { requiresAuth: true },
        },
        {
          path: '/system-settings',
          name: 'system-settings',
          component: () => import('../views/Settings/SystemSettingsView.vue'),
          meta: { requiresAuth: true },
        },
      ],
    },
  ],
})

// This is a global navigation guard that checks if the user is authenticated
// before navigating to a route that requires authentication. Or checks if app is locked.

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  const loggedIn = !!userStore.accessToken && !!userStore.userId

  if (to.name === 'login' && loggedIn) {
    console.debug('User is already logged in, redirecting to bank accounts')
    next('/') // redirect to home portal if user is already logged in
  } else if (to.meta.requiresAuth && !loggedIn) {
    console.debug('User is not logged in, redirecting to login')
    next('/login') // redirect to login if user is not authenticated
  } else {
    next()
  }
})

export default router
